"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as a, jsxs as A } from "react/jsx-runtime";
import * as m from "react";
import { SPACE as D } from "./utils/keys.js";
import { useControlProps as L } from "./form-context.js";
import N from "./inline.js";
import { Text3 as f } from "./text.js";
import { useAriaId as P, useTheme as R } from "./hooks.js";
import n from "classnames";
import { getPrefixedDataAttributes as S } from "./utils/dom.js";
import { checkboxContainerDisabled as E, checkboxContainer as V, disabled as x, check as u, checkChecked as k, boxVariant as j } from "./checkbox.css-mistica.js";
import { vars as v } from "./skins/skin-contract.css-mistica.js";
import { combineRefs as z } from "./utils/common.js";
const B = (param)=>{
    let { isChecked: e, disabled: c } = param;
    const { isIos: l } = R(), o = l ? /* @__PURE__ */ a("svg", {
        viewBox: "0 0 10 8",
        width: "10",
        height: "8",
        className: n(u, {
            [k]: e
        }),
        children: /* @__PURE__ */ a("path", {
            d: "M2.659 7.724c.33.366.92.368 1.254.005L9.79 1.336A.782.782 0 009.719.202a.858.858 0 00-1.178.069l-5.236 5.72-1.841-2.038a.857.857 0 00-1.177-.078.782.782 0 00-.082 1.133l2.454 2.716z",
            fill: v.colors.inverse
        })
    }) : /* @__PURE__ */ a("svg", {
        viewBox: "0 0 14 10",
        width: "14",
        height: "10",
        className: n(u, {
            [k]: e
        }),
        children: /* @__PURE__ */ a("path", {
            d: "M5 10L0 5.192l1.4-1.346L5 7.308 12.6 0 14 1.346z",
            fill: v.colors.inverse
        })
    });
    return /* @__PURE__ */ a("div", {
        className: n(j[e ? "checked" : l ? "ios" : "rest"], {
            [x]: c
        }),
        children: o
    });
}, K = /*#__PURE__*/ m.forwardRef((e, c)=>{
    const l = P(e["aria-labelledby"]), o = e["aria-label"], C = o || e["aria-labelledby"], { defaultValue: g, value: t, onChange: s, focusableRef: w, disabled: i } = L({
        name: e.name,
        value: e.checked,
        defaultValue: e.defaultChecked,
        onChange: e.onChange,
        disabled: e.disabled
    }), [r, y] = m.useState(!!g), h = ()=>{
        t === void 0 ? (y(!r), s(!r)) : s(!t);
    }, I = (d)=>{
        d.key === D && (d.preventDefault(), d.stopPropagation(), h());
    }, b = /* @__PURE__ */ a(B, {
        disabled: i,
        isChecked: t !== null && t !== void 0 ? t : r
    });
    return(// When the checkbox is disabled, it shouldn't be focusable
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ a("div", _object_spread_props(_object_spread({
        id: e.id,
        role: e.role || "checkbox",
        "aria-checked": t !== null && t !== void 0 ? t : r,
        onKeyDown: i ? void 0 : I,
        onClick: (d)=>{
            d.stopPropagation(), i || h();
        },
        tabIndex: i ? void 0 : 0,
        ref: z(c, w),
        className: i ? E : V,
        "aria-label": o,
        "aria-labelledby": o ? void 0 : l,
        "aria-disabled": i
    }, S(e.dataAttributes, "Checkbox")), {
        children: e.render ? e.render({
            controlElement: b,
            labelId: l,
            checked: t !== null && t !== void 0 ? t : r,
            disabled: !!i
        }) : /* @__PURE__ */ A(N, {
            space: 16,
            children: [
                /* @__PURE__ */ a(f, {
                    regular: !0,
                    as: "div",
                    children: /* @__PURE__ */ a("div", {
                        style: {
                            position: "relative",
                            top: -2
                        },
                        children: b
                    })
                }),
                e.children && /* @__PURE__ */ a(f, {
                    regular: !0,
                    as: "div",
                    id: l,
                    role: C ? "presentation" : void 0,
                    children: /* @__PURE__ */ a("span", {
                        className: i ? x : "",
                        children: e.children
                    })
                })
            ]
        })
    })));
}), W = K;
export { W as default };
